export default {
    state: {
        learns: [
            {
                title: 'Делись опытом',
                text: 'Участие в проектах в качестве наставника для состоявшихся профессионалов',
                link: '/portal/mentoring',
                img: 'left',
            },
            {
                title: '“Международная Премия #МЫВМЕСТЕ”',
                text: 'Премия для лидеров социальных изменений',
                link: 'https://xn--e1aglkf7g.xn--b1agazb5ah1e.xn--p1ai/',
                img: 'center',
            },
            {
                title: 'Благотворительный проект «Мечтай со мной»',
                text: 'Проект объединяет людей, которые помогают тяжелобольным детям и пожилым людям исполнять свои заветные желания',
                link: 'https://xn--80ajnaldhgc0ai3d.xn--p1ai/',
                img: 'right',
            },
        ],
        // tests: [
        //     {
        //         title: 'Тест "Где я могу быть полезен?"',
        //         text: '',
        //         link: '#',
        //         img: 'table',
        //     },
        //     {
        //         title: 'Тест "Лидерские качества"',
        //         text: '',
        //         link: '#',
        //         img: 'class',
        //     },
        // ],
    },
    getters: {
        gains_learns: state => state.learns,
        // gains_tests: state => state.tests,
    },
};
